<div class="portfolio-home">
  <header class="portfolio-header">
    <a
      class="portfolio-brand"
      [href]="accessDenied ? restrictedHomeUrl : '/home'"
      aria-label="AI-PHO home"
      ><img
        src="assets/landing-page/ai-pho-logo.png"
        alt="AI-PHO"
        width="124"
        height="32"
    /></a>
    <nav aria-label="Contact and access">
      <a
        class="contact-button"
        href="mailto:support.aipho@ab-inbev.com?subject=AIPHO%20Support%20Request&body=Hi%20AIPHO%20Team%2C%0A%0AI%E2%80%99m%20reaching%20out%20regarding%20AIPHO%20and%20would%20like%20more%20information.%0A%0AMy%20question%2Frequest%3A%0A%5BPlease%20add%20details%20here%5D%0A%0AThank%20you%2C%0A%5BYour%20name%5D%0A%5BYour%20market%2Fteam%5D"
        >Reach us</a
      >
      <button class="access-button" type="button" (click)="requestAccess()">
        Request access
      </button>
      @if (accessDenied || !isLoggedIn) {
        <button
          class="home-login-button"
          type="button"
          (click)="continueToLogin('/home', accessDenied)"
        >
          Login
        </button>
      }
      @if (!accessDenied && isLoggedIn && user.first_name) {
        <button
          mat-button
          class="home-user-menu"
          [matMenuTriggerFor]="homeUserMenu"
          [title]="fullName"
        >
          <span class="home-user-details">
            <span class="material-icons home-profile-icon" aria-hidden="true"
              >account_circle</span
            >
            <span class="home-user-name">{{ fullName }}</span>
            <span class="material-icons home-user-chevron" aria-hidden="true"
              >expand_more</span
            >
          </span>
        </button>
        <mat-menu
          #homeUserMenu="matMenu"
          yPosition="below"
          xPosition="before"
          class="user-dropdown"
        >
          <button mat-menu-item (click)="openUserPage('/studio/profile')">
            Profile
          </button>
          @if (canViewAdminPanel) {
            <button mat-menu-item (click)="openUserPage('/studio/admin-panel')">
              Admin Panel
            </button>
          }
          <button mat-menu-item (click)="showSupportTktDialog = true">
            Report a Bug
          </button>
          <button mat-menu-item (click)="openDocsInNewTab()">Docs</button>
          <button mat-menu-item (click)="logout()">Logout</button>
        </mat-menu>
      }
    </nav>
  </header>
  <main>
    <section class="portfolio-hero" aria-labelledby="portfolio-heading">
      <div class="portfolio-hero-copy">
        <p class="portfolio-eyebrow">AI-POWERED PORTFOLIO INTELLIGENCE</p>
        <h1 id="portfolio-heading">
          Make every<br /><span>SKU decision</span> count.
        </h1>
        <p class="portfolio-subtitle">
          Turn portfolio data into confident actions<br class="desktop-break" />
          across every market.
        </p>
      </div>
    </section>
    <div class="portfolio-overview">
      <section class="portfolio-products" aria-label="Portfolio products">
        <button
          class="portfolio-product"
          type="button"
          (click)="selectModule('pho')"
          [disabled]="accessDenied"
        >
          <span class="material-icons product-arrow" aria-hidden="true"
            >arrow_forward</span
          >
          <span class="product-symbol"
            ><img
              src="assets/landing-page/pho-icon.png"
              alt=""
              width="70"
              height="70"
          /></span>
          <span class="product-copy"
            ><strong>PHO</strong
            ><span
              >Simulate different scenarios to discover which SKU mix drives the
              highest incremental revenue for the retailer.</span
            ></span
          >
        </button>
        <button
          class="portfolio-product"
          type="button"
          (click)="selectModule('global-dashboard')"
          [disabled]="accessDenied"
        >
          <span class="material-icons product-arrow" aria-hidden="true"
            >arrow_forward</span
          >
          <span class="product-symbol"
            ><img
              src="assets/landing-page/global-insights-icon.png"
              alt=""
              width="70"
              height="70"
          /></span>
          <span class="product-copy"
            ><strong>Global Insights</strong
            ><span
              >Aggregate country data for a unified portfolio view, offering key
              KPIs and insights to optimize global performance.</span
            ></span
          >
        </button>
        <button
          class="portfolio-product"
          type="button"
          (click)="selectModule('pho_dtp')"
          [disabled]="accessDenied"
        >
          <span class="material-icons product-arrow" aria-hidden="true"
            >arrow_forward</span
          >
          <span class="product-symbol"
            ><img
              src="assets/landing-page/optimize-sku-icon.png"
              alt=""
              width="70"
              height="70"
          /></span>
          <span class="product-copy"
            ><strong>Optimize SKU Actions</strong
            ><span
              >Identify optimal SKUs using PPR and PINC values from previous
              plans.</span
            ></span
          >
        </button>
      </section>
      <section
        class="portfolio-summary"
        aria-label="Global portfolio performance"
      >
        <div class="portfolio-metrics">
          <div class="portfolio-metric">
            <span class="metric-symbol"
              ><img
                src="assets/landing-page/skus-icon.png"
                alt=""
                width="52"
                height="52"
            /></span>
            <div>
              <strong>{{ skusAnalyzed }}</strong
              ><span>SKUs analyzed</span>
            </div>
          </div>
          <div class="portfolio-metric">
            <span class="metric-symbol"
              ><img
                src="assets/landing-page/markets-icon.png"
                alt=""
                width="52"
                height="52"
            /></span>
            <div>
              <strong>{{ markets }}</strong
              ><span>markets</span>
            </div>
          </div>
          <div class="portfolio-metric">
            <span class="metric-symbol"
              ><img
                src="assets/landing-page/confidence-icon.png"
                alt=""
                width="52"
                height="52"
            /></span>
            <div>
              <strong>{{ decisionConfidence }}%</strong
              ><span>decision confidence</span>
            </div>
          </div>
        </div>
        <div class="portfolio-health">
          <div class="health-copy">
            <h2>Portfolio Health Index (PHI)</h2>
            <p>
              A single measure of portfolio strength<br />
              across all market SKUs.
            </p>
          </div>
          <div
            class="health-score"
            role="img"
            [attr.aria-label]="
              'Portfolio Health Index: ' +
              (portfolioHealthScore | number: '1.2-2') +
              ' out of 100'
            "
          >
            <svg viewBox="0 0 100 100" aria-hidden="true" focusable="false">
              <circle class="health-score-track" cx="50" cy="50" r="45" />
              <circle
                class="health-score-progress"
                cx="50"
                cy="50"
                r="45"
                pathLength="100"
                stroke-dasharray="100"
                [attr.stroke-dashoffset]="100 - portfolioHealthScore"
                [attr.visibility]="
                  portfolioHealthScore === 0 ? 'hidden' : 'visible'
                "
                transform="rotate(-90 50 50)"
              />
            </svg>
            <span>{{ portfolioHealthScore | number: "1.2-2" }}</span>
          </div>
          <p class="health-caption">
            Current Global<br />Portfolio Health Index
          </p>
        </div>
      </section>
    </div>
  </main>
</div>
<p-dialog
  header="Access unavailable"
  [(visible)]="showAccessDeniedDialog"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  styleClass="access-denied-dialog"
>
  <div class="access-denied-top">
    <img
      src="assets/images/aipho-logo-black.svg"
      alt="AI-PHO"
      width="194"
      height="52"
    />
    <button
      type="button"
      class="access-denied-close"
      aria-label="Close access message"
      title="Close"
      (click)="showAccessDeniedDialog = false"
    >
      <i class="pi pi-times" aria-hidden="true"></i>
    </button>
  </div>
  <h2 class="access-denied-title">{{ accessDeniedMessage }}</h2>
  <p class="access-denied-description">{{ accessDeniedSubMessage }}</p>
</p-dialog>
<app-request-access-dialog
  [(visible)]="showRequestAccessDialog"
  [title]="'Request Access'"
  [requestAccessForm]="requestAccessForm"
  [submitting]="requestSubmitting"
  [submitError]="requestSubmitError"
  [submitSuccess]="requestSubmitSuccess"
  (submitted)="onRequestAccessSubmit($event)"
></app-request-access-dialog>
@if (showSupportTktDialog) {
  <app-support-ticket [(visible)]="showSupportTktDialog"></app-support-ticket>
}
